import { ProductBadgeBase } from '@services/MarppleShop/renderApp/components/cells/ProductBadge/ProductBadgeBase.ts';
import {
  ProductBadgeListData,
  ProductBadgeListOption,
} from '@services/MarppleShop/renderApp/components/cells/ProductBadgeList/ProductBadgeList.ts';
import { filter, pipe, take, toArray } from '@fxts/core';
import { IProductBadgeStrategy, PageContext } from '../strategies/product-badge-strategy.interface';

/**
 * 뱃지 컨트롤러 (BadgeDefinition 사용)
 */
export class ProductBadgeListController {
  private readonly limit: number;

  constructor(
    private readonly data: Readonly<ProductBadgeListData>,
    private readonly option: Readonly<ProductBadgeListOption>,
    private readonly strategy: IProductBadgeStrategy<any>,
    private readonly pageContext: PageContext,
  ) {
    this.limit = option.max_length ?? Infinity;
  }

  createProductBadges(): ProductBadgeBase[] {
    const badgeDefinitions = this.strategy.getBadgeDefinitions();

    return pipe(
      badgeDefinitions,
      filter((definition) => definition.shouldShow(this.data, this.pageContext)),
      toArray,
      (badges) => badges.sort((a, b) => a.priority - b.priority),
      (badges) =>
        badges.map((definition) => definition.createBadge(this.data, this.option, this.pageContext)),
      filter((badge) => badge.isVisible()),
      take(this.limit),
      toArray,
    );
  }
}
